import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error';
import _ from "lodash";
import * as UTIL from '../../util';
import { tojsslink } from '../../util/tojsslink';
import { apiUtil } from '../../util';
var Creators = Actions.Creators;
var requestMenu = Creators.request;
var receiveMenu = Creators.response;
var categoryChangeMenu = Creators.categoryChange;
var requestFeatureMenu = Creators.featureRequest;
var receiveFeatureMenu = Creators.featureResponse;
var setDefaultMenu = Creators.setDefault;
var clearDefaultMenu = Creators.clearDefault;
var clearMenu = Creators.clearMenu;
var requestUpsell = Creators.requestUpsell;
var receiveUpsell = Creators.receiveUpsell;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;
var firstPath = typeof window !== 'undefined' ? window.location.pathname.split("/")[1] || "menu" : '';

function fetchMenu(state) {
  return function (dispatch) {
    dispatch(requestMenu());
    var storeId = UTIL.getStoreId(state, "lebanon-tn");
    var storeType = UTIL.getPageType(state);

    if (storeType !== state.menu.menuType || storeId !== state.menu.storeId) {
      dispatch(clearMenu());
    } // EXMAPLE ENDPOINT/sitecore/api/GetEatProductsByStoreAndCategory/{storeId}/{categoryId}


    var routeURL = "".concat(apiUtil.API.getMenu, "/").concat(storeId, "?catalog=").concat(firstPath);
    return UTIL.apiUtil.fetchGet(routeURL).then(function (json) {
      var categories = json.map(function (element) {
        var jssLink = tojsslink(element.DisplayName, element.CategoryContentPagePath, element.CategoryContentPageName.replace(/\s+/g, '-').toLowerCase(), element.Name);
        return _objectSpread(_objectSpread({}, jssLink), {}, {
          path: element.CategoryContentPagePath
        });
      });
      dispatch(receiveMenu({
        results: json,
        categories: categories,
        menuType: storeType,
        storeId: storeId
      }));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function fetchFeature(state, dataSource) {
  return function (dispatch) {
    dispatch(requestFeatureMenu());
    var storeId = UTIL.getStoreId(state, "lebanon-tn");
    var category = state.menu.currentCategory.featuredName;
    var params = "categoryId=".concat(category, "&datasource=").concat(dataSource);
    var routeURL = "".concat(apiUtil.API.getFeatures, "/").concat(storeId, "?").concat(params);

    var copy = _objectSpread({}, state.menu.features); // copy[dataSource] = featuredTest
    // return dispatch(receiveFeatureMenu({features: { ...copy}}))
    // EXMAPLE ENDPOINT https://crackerbarrel.dev.local/sitecore/api/GetSelectedProuctsByCategory?categoryId=CB_Food_Store-breakfast&datasource={82832555-C934-46C4-89BA-FCB1647AE04D}&storeId=


    return UTIL.apiUtil.fetchGet(routeURL).then(function (json) {
      copy[dataSource] = json;
      return dispatch(receiveFeatureMenu({
        features: _objectSpread({}, copy)
      }));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function fetchUpsell(state, dataSource) {
  return function (dispatch) {
    var _state$location, _state$location$locat, _state$location2, _state$location2$loca, _state$location3, _state$location3$loca, _state$location4, _state$location4$loca, _state$account, _state$account$aadRes;

    dispatch(requestUpsell());
    var storeId = (state === null || state === void 0 ? void 0 : (_state$location = state.location) === null || _state$location === void 0 ? void 0 : (_state$location$locat = _state$location.location) === null || _state$location$locat === void 0 ? void 0 : _state$location$locat.olo_unique_name) || ((_state$location2 = state.location) === null || _state$location2 === void 0 ? void 0 : (_state$location2$loca = _state$location2.location) === null || _state$location2$loca === void 0 ? void 0 : _state$location2$loca.oloUniqueName);
    var caterStoreId = (state === null || state === void 0 ? void 0 : (_state$location3 = state.location) === null || _state$location3 === void 0 ? void 0 : (_state$location3$loca = _state$location3.location) === null || _state$location3$loca === void 0 ? void 0 : _state$location3$loca.olo_catering_unique_name) || ((_state$location4 = state.location) === null || _state$location4 === void 0 ? void 0 : (_state$location4$loca = _state$location4.location) === null || _state$location4$loca === void 0 ? void 0 : _state$location4$loca.oloCateringUniqueName);
    var routeURL = "".concat(UTIL.apiUtil.API.getUpsell, "?datasource=").concat(dataSource, "&storeId=").concat(storeId, "&cateringStoreId=").concat(caterStoreId);
    var token = (_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : _state$account$aadRes.jwtIdToken;

    var copy = _objectSpread({}, state.menu.upsell);

    return UTIL.apiUtil.fetchGet(routeURL, token).then(function (json) {
      copy[dataSource] = json;
      return dispatch(receiveUpsell({
        upsell: _objectSpread({}, copy)
      }));
    }).catch(function (err) {
      console.log(err);
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function getProductId(state, productUrl, location) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = apiUtil.API.getProductId.replace('{location}', location).replace('{productUrl}', productUrl);
              return _context.abrupt("return", UTIL.apiUtil.fetchGet(url).then(function (res) {
                return res || null;
              }).catch(function (err) {
                console.error('Error getting product id', err);
                dispatch(receiveError(UTIL.buildError(UTIL.buildInternalError('cb7504'))));
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function changeCategory(currentCategory) {
  return function (dispatch) {
    return dispatch(categoryChangeMenu({
      currentCategory: currentCategory
    }));
  };
}

var getMenu = function getMenu() {
  return function (dispatch, getState) {
    return dispatch(fetchMenu(getState()));
  };
};

var getFeatures = function getFeatures(dataSource) {
  return function (dispatch, getState) {
    return dispatch(fetchFeature(getState(), dataSource));
  };
};

var getUpsell = function getUpsell(dataSource) {
  return function (dispatch, getState) {
    return dispatch(fetchUpsell(getState(), dataSource));
  };
};

var setDefault = function setDefault(defaultOptions) {
  return function (dispatch) {
    return dispatch(setDefaultMenu({
      defaultOptions: defaultOptions
    }));
  };
};

var clearDefault = function clearDefault() {
  return function (dispatch, getState) {
    return dispatch(clearDefaultMenu(getState()));
  };
};

var handleGetProductId = function handleGetProductId(productUrl, location) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dispatch(getProductId(getState(), productUrl, location)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

export default {
  getMenu: getMenu,
  receiveError: receiveError,
  changeCategory: changeCategory,
  getFeatures: getFeatures,
  setDefault: setDefault,
  clearDefault: clearDefault,
  getUpsell: getUpsell,
  handleGetProductId: handleGetProductId
};